import { Component, inject, viewChild, signal, ElementRef, computed } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Sort } from '@angular/material/sort';

// Services & Models
import { IntuneUser } from '../../../../../Models/Intune/intune-user.model';
import { COMMON_IMPORTS } from '../../../../Shared/common-imports';
import { AvTableLoadingBarComponent } from '../../../../Shared/Components/loading-bar/table-loading-bar.component';
import { AvTableCopyCellComponent } from '../../../../Shared/Components/table-copy-cell/table-copy-cell.component';
import { ListUsersFacade } from '../../../../../Facades/Intune/list-users.facade';

@Component({
  selector: 'app-all-users-table',
  standalone: true,
  imports: [COMMON_IMPORTS, AvTableLoadingBarComponent, AvTableCopyCellComponent],
  templateUrl: './all-users-table.component.html',
  styleUrls: ['./all-users-table.component.scss', '../../../../../../assets/theme/cutom/_av-table.scss']
})
export class AllUsersTableComponent {
  readonly facade = inject(ListUsersFacade);
  isBottomReached = signal(false);

  dataSource = computed(() => {
    const source = new MatTableDataSource<IntuneUser>(this.facade.users());
    return source;
  });
  displayedColumns: string[] = ['index', 'name', 'email', 'employeeId', 'jobTitle', 'department', 'mobilePhone', 'phone', 'action'];

  bottomDetector = viewChild<ElementRef>('bottomDetector');
  tableWrapper = viewChild<ElementRef>('tableWrapper');

  private _observer: IntersectionObserver | null = null;

  ngAfterViewInit() {
    this.setupScrollObserver();
  }

  ngOnDestroy() {
    if (this._observer) {
      this._observer.disconnect();
    }
    this.facade.clear();
  }

  private setupScrollObserver() {
    const bottomDetectorElement = this.bottomDetector()?.nativeElement;

    if (!bottomDetectorElement) return;

    this._observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        this.isBottomReached.set(entry.isIntersecting);
      });
    }, {
      root: this.tableWrapper()?.nativeElement || null,
      threshold: 0.1,
      rootMargin: '0px'
    });

    this._observer.observe(bottomDetectorElement);
  }

  onSortChange(sort: Sort) {
    const columnMap: Record<string, string> = {
      'name': 'displayName',
      'email': 'userPrincipalName',
      'country': 'country'
    };

    const apiColumn = columnMap[sort.active];
    if (apiColumn) {
      const direction = sort.direction === '' ? 'asc' : sort.direction as 'asc' | 'desc';
      this.facade.setSort(apiColumn, direction);
    }
  }

}